import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useLookupCustomers = () =>
  useMutation({
    mutationFn: () => client("lookups/customers"),
  });
export const useLookupServicePoints = () =>
  useMutation({
    mutationFn: (customerId) =>
      client(`lookups/customer/cit/sites/${customerId}`),
  });
export const useLookupMachinesServicePoints = () =>
  useMutation({
    mutationFn: (customerId) =>
      client(`lookups/customer/machine/sites/${customerId}`),
  });
export const useLookupActivityTypes = () =>
  useMutation({
    mutationFn: () => client(`lookups/activity/types`),
  });

export const useLookupCCAActivityTypes = () =>
  useMutation({
    mutationFn: () => client(`lookups/activity/types/cca`),
  });
export const useLookupCategories = () =>
  useMutation({
    mutationFn: (activityType) =>
      client(`lookups/activity/categories/${activityType}`),
  });
export const useLookupSubCategories = () =>
  useMutation({
    mutationFn: (data) =>
      client(
        `lookups/activity/sub/categories/${data.activityType}/${data.category}`
      ),
  });
export const useLookupAssignmentGroups = () =>
  useMutation({
    mutationFn: (data) =>
      client(`lookups/assignment/groups/${data.region}/${data.activityType}`),
  });
export const useLookupAllAssignmentGroups = () =>
  useMutation({
    mutationFn: () => client(`lookups/assignment/groups`),
  });
export const useLookupPendingReasons = () =>
  useMutation({
    mutationFn: (category) => client(`lookups/pending/reasons/${category}`),
  });
export const useLookupCashCenters = () =>
  useMutation({
    mutationFn: () => client(`lookups/cash/centers`),
  });

export const useLookupAllRoute = () =>
  useMutation({
    mutationFn: () => client(`lookups/all/routes`),
  });

export const useLookupResolutionCodes = () =>
  useMutation({
    mutationFn: () => client(`lookups/resolution/codes`),
  });
export const useLookupResolutionCodesViaCategory = () =>
  useMutation({
    mutationFn: (category) => client(`lookups/resolution/codes/${category}`),
  });
